module.exports = __webpack_public_path__ + "img/vanity2.2a09db73.jpg";